var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzureShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94043 12.6884C8.86816 12.3485 10.459 12.0673 10.4766 12.0614L10.5088 12.0556L8.68945 9.89053C7.6875 8.70108 6.87012 7.72256 6.87012 7.7167C6.87012 7.70498 8.74805 2.53115 8.75977 2.51358C8.7627 2.50772 10.043 4.71377 11.8594 7.86318C13.5615 10.8105 14.9619 13.2421 14.9766 13.2655L15 13.3065H9.2168H3.43359L6.94043 12.6884ZM0 12.0292C0 12.0263 0.858398 10.538 1.9043 8.72158L3.80859 5.41983L6.0293 3.55654C7.25098 2.53115 8.25293 1.69326 8.25586 1.69033C8.25879 1.6874 8.24414 1.72842 8.2207 1.78115C8.19727 1.83096 7.11328 4.16006 5.80957 6.95205L3.44238 12.0292L1.71973 12.0321C0.773438 12.0321 0 12.0321 0 12.0292Z",
    fill: "#0089D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureShort);
export default __webpack_public_path__ + "static/media/Azure-Short.f2e0ec52f067e0c7771284ee84d52264.svg";
export { ForwardRef as ReactComponent };